// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disclaimers[data-v-739a28d5]{margin-top:2rem}.disclaimers[data-v-739a28d5] p{font-size:10px}
`, "",{"version":3,"sources":["webpack://./../assets/vue/Disclaimers.vue"],"names":[],"mappings":"AACA,8BAKE,eAAgB,CALlB,gCAEI,cAAe","sourcesContent":["\n.disclaimers {\n  :deep(p) {\n    font-size: 10px;\n  }\n\n  margin-top: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
